export type WorkspaceProject = {
  worktree: string
  vcs?: string
}

export function upsertInitializedProject<T extends WorkspaceProject & { id: string }>(projects: T[], next: T): T[] {
  const match = (project: T) => project.id === next.id || project.worktree === next.worktree
  if (projects.some(match)) return projects.map((project) => (match(project) ? next : project))
  return [...projects, next].toSorted((a, b) => a.id.localeCompare(b.id))
}

export async function toggleProjectWorkspaceSetting(input: {
  project: WorkspaceProject
  enabled: boolean
  initializeGit: (directory: string) => Promise<void>
  createWorkspace: (directory: string) => Promise<boolean>
  toggle: (directory: string) => void
}) {
  if (!input.enabled && input.project.vcs !== "git") {
    await input.initializeGit(input.project.worktree)
    if (!(await input.createWorkspace(input.project.worktree))) return "creation_failed" as const
  }
  input.toggle(input.project.worktree)
  return input.enabled ? ("disabled" as const) : ("enabled" as const)
}
